import React, { useState } from "react";
import styles from "../lauraperaroclinic/lauraperaroclinic.module.scss";
import Background from "./src/background-links.png";
import LinkPersonalizado7 from "../../components/LinkPersonalizado7/linkPersonalizado7.tsx";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import CatalogIcon from "../../icons/catalogIcon.tsx";
import InfoIcon from "../../icons/infoIcon.tsx";
import catalogoPdf from "./src/catalogo.pdf";

const Lauraperaroclinic: React.FC = () => {
    const [showContatos, setShowContatos] = useState(false);
    const [showLocalizacoes, setShowLocalizacoes] = useState(false);

    return (
        <div className={styles.lauraperaroclinic}>
            <div
                className={styles["body-thunder"]}
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className={styles["container-thunder"]}>
                    <h1 className="pt-2">Laura Peraro</h1>
                    <p>CLÍNICA DE ESTÉTICA AVANÇADA</p>

                    <div className={styles.links}>
                        <LinkPersonalizado7
                            topLeft
                            linkInterno
                            href="/lauraperaroclinic/sobremim"
                            title="SOBRE MIM"
                            icon={<InfoIcon height="32" color="#cbb353" />}
                            colorText="#333333"
                        />
                        <LinkPersonalizado7
                            topRight
                            href={catalogoPdf}
                            title="CATÁLOGO"
                            icon={<CatalogIcon height="34" color="#cbb353" />}
                            colorText="#333333"
                        />
                        <div onClick={() => setShowContatos(true)}>
                            <LinkPersonalizado7
                                noLink
                                href=""
                                title="CONTATOS"
                                icon={<WhatsappIcon height="34" color="#cbb353" />}
                                colorText="#333333"
                            />
                        </div>
                        <div onClick={() => setShowLocalizacoes(true)}>
                            <LinkPersonalizado7
                                noLink
                                href=""
                                title="LOCALIZAÇÕES"
                                icon={<MapsIcon height="34" color="#cbb353" />}
                                colorText="#333333"
                            />
                        </div>
                        <LinkPersonalizado7
                            href="https://www.instagram.com/lauraperaroclinic?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            icon={<InstagramIcon height="30" color="#cbb353" />}
                            colorText="#333333"
                        />
                    </div>
                </div>
            </div>

            {/* Modal CONTATOS */}
            {showContatos && (
                <div className={styles.modalOverlay} onClick={() => setShowContatos(false)}>
                    <div
                        className={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className={styles.closeButton}
                            onClick={() => setShowContatos(false)}
                        >
                            ✕
                        </button>
                        <h2>Contatos</h2>
                        <div className={styles.modalGrid}>
                            <div className={styles.modalCard}>
                                <h3>Barretos - SP</h3>
                                <p>(17) 99633-8485</p>
                                <a
                                    href="https://wa.me/5517996338485?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <WhatsappIcon height="18" color="#fff" />
                                        <span>WhatsApp</span>
                                    </button>
                                </a>
                            </div>
                            <div className={styles.modalCard}>
                                <h3>Guaíra - SP</h3>
                                <p>(17) 98162-2635</p>
                                <a
                                    href="https://wa.me/5517981622635?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <WhatsappIcon height="18" color="#fff" />
                                        <span>WhatsApp</span>
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal LOCALIZAÇÕES */}
            {showLocalizacoes && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setShowLocalizacoes(false)}
                >
                    <div
                        className={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className={styles.closeButton}
                            onClick={() => setShowLocalizacoes(false)}
                        >
                            ✕
                        </button>
                        <h2>Localizações</h2>
                        <div className={styles.modalGrid}>
                            <div className={styles.modalCard}>
                                <h3>Barretos - SP</h3>
                                <p>Rua Argentina 1560 - Sala 42</p>
                                <a
                                    href="https://maps.app.goo.gl/YBGJPkHGMCZUHte89"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <MapsIcon height="18" color="#fff" />
                                        <span>Ver no mapa</span>
                                    </button>
                                </a>
                            </div>
                            <div className={styles.modalCard}>
                                <h3>Guaíra - SP</h3>
                                <p>Rua 20, 020 - Centro</p>
                                <a
                                    href="https://maps.app.goo.gl/ms18kNAfBJ1bQRvw6"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <MapsIcon height="18" color="#fff" />
                                        <span>Ver no mapa</span>
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Lauraperaroclinic;
